import React from 'react'
import ExclusiveToggleGroup from '../../components/editors/toggle/ExclusiveToggleGroup'
import { intl } from '../../../i18n'
import {
  AggregateTarget,
  WbsItemType,
} from '../../../domain/entity/WbsItemEntity'
import deliverableSvg from '../../../assets/deliverable.svg'
import taskSvg from '../../../assets/task.svg'

export const AggregateTargetToggleGroup = (props: {
  value: AggregateTarget
  onChange: (value: AggregateTarget) => void
  height?: number
}) => {
  return (
    <ExclusiveToggleGroup
      value={props.value}
      options={[
        {
          label: intl.formatMessage({
            id: 'wbsItemType.deliverable',
          }),
          value: WbsItemType.DELIVERABLE,
          iconUrl: deliverableSvg,
        },
        {
          label: intl.formatMessage({
            id: 'wbsItemType.task',
          }),
          value: WbsItemType.TASK,
          iconUrl: taskSvg,
        },
      ]}
      onChange={value =>
        props.onChange(value as WbsItemType.DELIVERABLE | WbsItemType.TASK)
      }
      height={props.height}
    />
  )
}
